function initializeTabsEvents(tabSectionIndex, tabSection) {
    const $tabContentsContainer = $(tabSection).find(".pd-tabs-section__content");
    const $tabsNavHeader        = $(tabSection).find(".pd-tabs-section__nav");
    const $tabsButtons          = $tabsNavHeader.find(".pd-tabs-section__button");

    $tabsButtons.each(function (index, tabButton) {
        $(tabButton).on("click", function (evt) {
            const $currentButton = $(evt.currentTarget);

            tabClickEffect(index, $currentButton, $tabsNavHeader);
            unactiveAllTabs();
            $currentButton.addClass("active");

            const contentDOMSelector = $currentButton.data("target");

            hideAllTabsContent();
            showTabContentBySelector(`#${contentDOMSelector}`);
        });
    });

    const unactiveAllTabs = () => {
        $tabsButtons.removeClass("active");
    };

    const hideAllTabsContent = () => {
        $tabContentsContainer.find("> div").hide("fast");
    };

    const showTabContentBySelector = (contentDOM) => {
        $(contentDOM).parent().show("fast");
    };
}

function tabClickEffect(index, $tabButton, $tabsNavHeader) {
    const widthButtonsUntilCurrent =
        $tabsNavHeader.find(".pd-tabs-section__button")
            .toArray()
            .reduce((acc, btn, i) =>
                i < index ?
                    acc + $(btn).innerWidth() : acc
            , 0);

    const OFFSET_SCROLL_LEFT = 50;
    const TABS_GAP           = 16;

    const tabsNavHeaderGap                = $tabsNavHeader.css("gap");
    const widthButtonsUntilCurrentWithGap = `calc(${widthButtonsUntilCurrent}px + ${tabsNavHeaderGap} * ${index})`;

    const tabButtonOffsetLeft     = $tabButton.offset().left;
    const tabButtonWidth          = $tabButton.outerWidth();
    const tabsNavHeaderScrollLeft = $tabsNavHeader.scrollLeft();
    const scrollWidth             = $tabsNavHeader[0].scrollWidth;
    const tabsNavHeaderWidth      = $tabsNavHeader.width();
    const tabButtonOffsetRight    = tabButtonOffsetLeft + tabButtonWidth;


    if (window.innerWidth >= 992) {
        if (index === 0) {
            $tabsNavHeader.animate({
                scrollLeft: 0
            }, 300);
        } else if ($tabsNavHeader.children().length === (index + 1)) {
            $tabsNavHeader.animate({
                scrollLeft: scrollWidth
            }, 300);
        } else if (tabButtonOffsetLeft < tabsNavHeaderScrollLeft) {
            $tabsNavHeader.animate({
                scrollLeft: tabButtonOffsetLeft - $tabsNavHeader.offset().left
            }, 300);
        } else if (tabButtonOffsetRight > tabsNavHeaderScrollLeft + tabsNavHeaderWidth) {
            $tabsNavHeader.animate({
                scrollLeft: tabButtonOffsetRight - tabsNavHeaderWidth + $tabsNavHeader.offset().left
            }, 300);
        }
    } else {
        if (index === 0) {
            $tabsNavHeader.animate({
                scrollLeft: 0
            }, 300);
        } else if ($tabsNavHeader.children().length === (index + 1)) {
            $tabsNavHeader.animate({
                scrollLeft: scrollWidth
            }, 300);
        } else {
            $tabsNavHeader.animate({
                scrollLeft: (widthButtonsUntilCurrent + TABS_GAP * index) - OFFSET_SCROLL_LEFT
            }, 300);
        }
    }

    $tabsNavHeader.css("--tabBackgroundPosition", widthButtonsUntilCurrentWithGap);
    $tabsNavHeader.css("--tabBackgroundWidth", `${$tabButton.innerWidth()}px`);
}

function activeFirstTab(tabSection) {
    const $tabsNavHeader = $(tabSection).find(".pd-tabs-section__nav");
    const $tabsButtons   = $tabsNavHeader.find(".pd-tabs-section__button");

    $tabsButtons.first().trigger("click");
}

function initializeSearchFilter($tabSection) {
    const $searchInput = $tabSection.find("#search-on-tabs-input");

    if (!$searchInput.length) {
        return;
    }

    $searchInput.on("input", function () {
        const searchText = $(this).val().toLowerCase().trim();

        if (searchText === "") {
            resetAllFilters($tabSection);
            return;
        }

        filterContentBySearch($tabSection, searchText);
    });
}

function resetAllFilters($tabSection) {
    const $allCollapses = $tabSection.find(".pd-collapse-component");
    const $allFiles     = $tabSection.find(".pd-file-download");

    $allCollapses.show();
    $allFiles.show();
}

function filterContentBySearch($tabSection, searchText) {
    const $tabContentSection = $tabSection.find(".pd-tabs-section__content");
    const $allCollapses      = $tabContentSection.find(".pd-collapse-component");

    $allCollapses.each(function () {
        const $collapse        = $(this);
        const collapseTitle    = $collapse.find(".pd-collapse-component__title").text().toLowerCase();
        const $filesInCollapse = $collapse.find(".pd-file-download");

        let hasVisibleFiles      = false;
        let collapseTitleMatches = collapseTitle.includes(searchText);

        $filesInCollapse.each(function () {
            const $file       = $(this);
            const fileTitle   = $file.find(".pd-file-download__title").text().toLowerCase();
            const fileMatches = fileTitle.includes(searchText);

            if (fileMatches || collapseTitleMatches) {
                $file.show();
                hasVisibleFiles = true;
            } else {
                $file.hide();
            }
        });

        if (collapseTitleMatches || hasVisibleFiles) {
            $collapse.show();
        } else {
            $collapse.hide();
        }
    });
}

function InitializeTabs() {
    console.log("tabsSection.js loaded");

    const $tabsSections = $(".pd-tabs-with-search-section");

    $tabsSections.each(function (index, tabSection) {
        const $tabSection = $(tabSection);

        initializeTabsEvents(index, tabSection);
        activeFirstTab(tabSection);
        initializeSearchFilter($tabSection);
    });
}

export default InitializeTabs;
